module.exports = __webpack_public_path__ + "static/media/two-boys.a40a6685.png";